export default "__VITE_ASSET__DXDsnoIl__"